const API_BASE = import.meta.env.VITE_API_BASE_URL || 'https://coder-api.finhub.workers.dev';
export function getToken() {
    return localStorage.getItem('auth_token');
}
export function setToken(token) {
    localStorage.setItem('auth_token', token);
}
export function clearToken() {
    localStorage.removeItem('auth_token');
}
export class ApiError extends Error {
    constructor(status, message) {
        super(message);
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: status
        });
    }
}
export async function apiFetch(path, options = {}) {
    const token = getToken();
    const res = await fetch(`${API_BASE}${path}`, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
            ...options.headers,
        },
    });
    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new ApiError(res.status, body.error || res.statusText);
    }
    return res.json();
}
